// const baseURL = "http://localhost:8000/api/v1"
const baseURL = "https://api.rentbeta.africa/api/v1";
const imageURL = "https://api.rentbeta.africa"
// const imageURL = "http://localhost:8000"


export { baseURL, imageURL }